var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployee1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D6A1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 15.228C15.8367 15.228 16.7374 15.4287 17.512 15.83C18.296 16.2313 18.898 16.8053 19.318 17.552C19.7474 18.2893 19.962 19.148 19.962 20.128C19.962 21.108 19.7474 21.9667 19.318 22.704C18.898 23.432 18.296 23.9967 17.512 24.398C16.7374 24.7993 15.8367 25 14.81 25H11.394V15.228H14.81ZM14.74 23.334C15.7667 23.334 16.56 23.054 17.12 22.494C17.68 21.934 17.96 21.1453 17.96 20.128C17.96 19.1107 17.68 18.3173 17.12 17.748C16.56 17.1693 15.7667 16.88 14.74 16.88H13.354V23.334H14.74ZM26.6092 25L24.4532 21.192H23.5292V25H21.5692V15.228H25.2372C25.9932 15.228 26.6372 15.3633 27.1692 15.634C27.7012 15.8953 28.0979 16.2547 28.3592 16.712C28.6299 17.16 28.7652 17.664 28.7652 18.224C28.7652 18.868 28.5785 19.4513 28.2052 19.974C27.8319 20.4873 27.2765 20.842 26.5392 21.038L28.8772 25H26.6092ZM23.5292 19.722H25.1672C25.6992 19.722 26.0959 19.596 26.3572 19.344C26.6185 19.0827 26.7492 18.7233 26.7492 18.266C26.7492 17.818 26.6185 17.4727 26.3572 17.23C26.0959 16.978 25.6992 16.852 25.1672 16.852H23.5292V19.722Z",
    fill: "#D6A1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee1);
export default __webpack_public_path__ + "static/media/employee1.107c3d7331a202257ad0e0aae90076c1.svg";
export { ForwardRef as ReactComponent };